import { useEffect } from "react";

// Dependency-free per-route SEO: updates document.title + key meta tags on route change.
// Crawler-visible on the deployed app when the bot-prerender toggle is on.
const setMeta = (selector, attr, content) => {
  if (!content) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [kind, name] = attr;
    el.setAttribute(kind, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta('meta[name="description"]', ["name", "description"], description);
      setMeta('meta[property="og:title"]', ["property", "og:title"], title);
      setMeta('meta[property="og:description"]', ["property", "og:description"], description);
      setMeta('meta[name="twitter:title"]', ["name", "twitter:title"], title);
      setMeta('meta[name="twitter:description"]', ["name", "twitter:description"], description);
    }
  }, [title, description]);
  return null;
};
